import { Box, VStack, HStack, Stack, Center, Divider } from "@chakra-ui/react";
import { Paragraph01, Paragraph02, Paragraph03 } from "~/components/Texts";
import { formatPrice } from "~/utils/Formatters";

export default function OrderDetailsProducts({ shop, order }) {
  return (
    <VStack w="100%" spacing="4" align="flex-start" p="4">
      <Paragraph01>
        <b>Productos</b>
      </Paragraph01>
      {order.products.map((product) => (
        <VStack w="100%" key={`product_detail_${product.id}`} py="2">
          <Stack
            direction={{ base: "column", md: "row" }}
            w="100%"
            spacing="4"
            justify="space-between"
          >
            <HStack spacing="4">
              <Center
                boxSize="72px"
                backgroundColor={shop.theme.colors.background.strong}
                borderRadius={shop.theme.radius}
              >
                <img
                  src={product.images[0] ? product.images[0].src : null}
                  objectFit="cover"
                  draggable="false"
                />
              </Center>
              <Paragraph02>{product.name.es}</Paragraph02>
            </HStack>
            <HStack spacing="4">
              <Paragraph02>{`${product.orderQuantity} ${
                product.orderQuantity > 1 ? "unidades" : "unidad"
              }`}</Paragraph02>
              <Paragraph02>{`${
                product.orderQuantity
              } x ${order.payment.isoCurrency.toUpperCase()} $${formatPrice(
                product.price.ars
              )}`}</Paragraph02>
            </HStack>
          </Stack>
        </VStack>
      ))}
      <Divider
        w="100%"
        h="2px"
        backgroundColor={shop.theme.colors.background.strong}
      />
      {order.shipping.cost && (
        <HStack w="100%">
          <Box flex="1">
            <Paragraph03>Envío</Paragraph03>
          </Box>
          <Paragraph03>+${formatPrice(order.shipping.cost)}</Paragraph03>
        </HStack>
      )}
      <HStack w="100%">
        <Box flex="1">
          <Paragraph02>Total</Paragraph02>
        </Box>
        <Paragraph02>
          <b>
            {order.payment.isoCurrency.toUpperCase()} $
            {formatPrice(order.payment.totalAmount)}
          </b>
        </Paragraph02>
      </HStack>
    </VStack>
  );
}
